var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading || _vm.error
    ? _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "row justify-center items-center" }, [
          _c(
            "div",
            { staticClass: "col-auto" },
            [
              _vm.error
                ? _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c("q-icon", {
                        attrs: { color: "negative", name: "info" }
                      }),
                      _vm._v("\n        Error occurred "),
                      _c("br"),
                      _c("q-btn", {
                        staticClass: "q-mt-xs",
                        attrs: { icon: "refresh", label: "Try again" },
                        on: {
                          click: function($event) {
                            _vm.init()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm.loading
                ? _c("q-spinner-puff", {
                    attrs: { color: "primary", size: "60px" }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ])
    : _c("div", { staticClass: "col-12" }, [
        _c(
          "div",
          { staticClass: "row gutter-md full-height" },
          [
            _vm._t("before-timeline", null, { model: _vm.model }),
            _c(
              "div",
              { staticClass: "col" },
              [
                _c(
                  "q-card",
                  { staticClass: "full-height" },
                  [
                    _c(
                      "q-card-title",
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.timelineTitle) +
                            "\n          "
                        ),
                        _vm.actions && _vm.actions.length
                          ? _c(
                              "q-icon",
                              {
                                directives: [
                                  { name: "tippy", rawName: "v-tippy" }
                                ],
                                attrs: {
                                  slot: "right",
                                  name: "more_vert",
                                  title: "More"
                                },
                                slot: "right"
                              },
                              [
                                _c(
                                  "q-popover",
                                  [
                                    _c(
                                      "q-list",
                                      {
                                        staticClass: "no-border",
                                        attrs: { link: "" }
                                      },
                                      _vm._l(_vm.actions, function(
                                        action,
                                        actionIndex
                                      ) {
                                        return _c(
                                          "q-item",
                                          {
                                            directives: [
                                              {
                                                name: "close-overlay",
                                                rawName: "v-close-overlay"
                                              }
                                            ],
                                            key: actionIndex,
                                            attrs: {
                                              disabled: action.disabled
                                            },
                                            nativeOn: {
                                              click: function($event) {
                                                return (function() {
                                                  return !action.disabled &&
                                                    action.handler
                                                    ? action.handler(_vm.model)
                                                    : ""
                                                })($event)
                                              }
                                            }
                                          },
                                          [
                                            action.url
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticStyle: {
                                                      "text-decoration": "none"
                                                    },
                                                    attrs: { href: action.url }
                                                  },
                                                  [
                                                    _c("q-item-main", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(action.label) +
                                                          "\n                    "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              : _c("q-item-main", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(action.label) +
                                                      "\n                  "
                                                  )
                                                ])
                                          ],
                                          1
                                        )
                                      })
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "q-card-main",
                      { attrs: { id: "card-main-timeline" } },
                      [
                        _vm.activities.length !== 0
                          ? _c(
                              "q-timeline",
                              { attrs: { color: "secondary" } },
                              _vm._l(_vm.activities, function(
                                activity,
                                activityIndex
                              ) {
                                return _c(
                                  "q-timeline-entry",
                                  {
                                    key: activity.id,
                                    class: activity.type,
                                    attrs: {
                                      title: activity.title,
                                      side:
                                        activityIndex % 2 === 0
                                          ? "left"
                                          : "right"
                                    }
                                  },
                                  [
                                    _c("SdDatetime", {
                                      staticClass: "q-timeline-subtitle",
                                      attrs: {
                                        slot: "subtitle",
                                        value: activity.created_at,
                                        "market-id": _vm.marketId,
                                        timezone: _vm.timezone
                                      },
                                      slot: "subtitle"
                                    }),
                                    _vm.has(activity, "data.summary.email")
                                      ? _c(
                                          "q-chip",
                                          {
                                            staticClass: "py-1 px-2 mx-1",
                                            attrs: {
                                              dense: "",
                                              color: _vm.chipColor(
                                                activity.data.summary.email
                                              ),
                                              "text-color": "white",
                                              icon: "mail"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                Email\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.has(activity, "data.summary.sms")
                                      ? _c(
                                          "q-chip",
                                          {
                                            staticClass: "py-1 px-2 mx-1",
                                            attrs: {
                                              dense: "",
                                              color: _vm.chipColor(
                                                activity.data.summary.sms
                                              ),
                                              "text-color": "white",
                                              icon: "sms"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                SMS\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.has(activity, "data.summary.push")
                                      ? _c(
                                          "q-chip",
                                          {
                                            staticClass: "py-1 px-2 mx-1",
                                            attrs: {
                                              dense: "",
                                              color: _vm.chipColor(
                                                activity.data.summary.push
                                              ),
                                              "text-color": "white",
                                              icon: "notifications"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                Push Notification\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.has(activity, "data.success") &&
                                    activity.data.success === false
                                      ? _c(
                                          "q-chip",
                                          {
                                            staticClass: "py-1 px-2 mx-1",
                                            attrs: {
                                              dense: "",
                                              color: "red",
                                              "text-color": "white",
                                              icon: "error"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                Failed Delivery\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.has(activity, "data.success") &&
                                    activity.data.success === true &&
                                    !_vm.get(activity, "data.summary.sms") &&
                                    !_vm.get(activity, "data.summary.push") &&
                                    !_vm.get(activity, "data.summary.email")
                                      ? _c(
                                          "q-chip",
                                          {
                                            staticClass: "py-1 px-2 mx-1",
                                            attrs: {
                                              dense: "",
                                              color: "green",
                                              "text-color": "white",
                                              icon: "info"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                Fallback Success\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "row gutter-xs items-center"
                                      },
                                      [
                                        _c("div", { staticClass: "col-auto" }, [
                                          activity.causer
                                            ? _c("img", {
                                                staticClass: "float-left round",
                                                staticStyle: { width: "40px" },
                                                attrs: {
                                                  src:
                                                    activity.causer
                                                      .avatar_file_url
                                                }
                                              })
                                            : _c("img", {
                                                staticClass: "float-left round",
                                                staticStyle: { width: "40px" },
                                                attrs: {
                                                  src:
                                                    "statics/icons/favicon-96x96.png"
                                                }
                                              })
                                        ]),
                                        _c("div", {
                                          staticClass: "col",
                                          domProps: {
                                            innerHTML: _vm._s(activity.content)
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              })
                            )
                          : _vm.activities.length === 0
                          ? _c("h4", { staticClass: "text-center" }, [
                              _vm._v(
                                "\n            No activities found\n          "
                              )
                            ])
                          : _vm._e(),
                        !_vm.hideInfiniteScroll
                          ? _c(
                              "infinite-loading",
                              { on: { infinite: _vm.fetchMoreActivities } },
                              [
                                _c("q-spinner-oval", {
                                  attrs: { slot: "spinner", size: 40 },
                                  slot: "spinner"
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          2
        )
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }